module.exports = __webpack_public_path__ + "img/ecu.5d6fdbf8.svg";